import router from "@/router";

export function clearToken(redirect = true): void {
  let actor = "organizer";
  switch (router.currentRoute.name) {
    case "school-dashboard":
    case "school-dashboard-event-stats":
      clearSchoolToken();
      actor = "organizer";
      break;
    case "job-fair-detail":
    case "company-detail":
      clearCandidateToken();
      actor = "candidate";
      break;
    case "company-dashboard":
      clearCompanyToken();
      actor = "company";
      break;
    default:
      break;
  }
  if (redirect) {
    setTimeout(() => {
      if (actor === "organizer") {
        router.push({
          name: "unauthenticated-organizer",
          params: { slug: router.currentRoute.params.slug },
        });
      } else {
        router.push({
          name: "unauthenticated",
          params: { actor },
        });
      }
    }, 500);
  }
}

export function getToken(): string | null {
  switch (router.currentRoute.name) {
    case "school-dashboard":
    case "school-dashboard-event-stats":
      return getSchoolToken();
    case "job-fair-detail":
    case "company-detail":
      return getCandidateToken();
    case "company-dashboard":
      return getCompanyToken();
    default:
      return null;
  }
}

export function setSchoolToken(token: string): void {
  localStorage.setItem("school_token", token);
}

export function getSchoolToken(): string | null {
  return localStorage.getItem("school_token");
}

export function clearSchoolToken(): void {
  localStorage.removeItem("school_token");
}

export function setCandidateToken(token: string): void {
  localStorage.setItem("candidate_token", token);
}

export function getCandidateToken(): string | null {
  return localStorage.getItem("candidate_token");
}

export function clearCandidateToken(): void {
  localStorage.removeItem("candidate_token");
}

export function setCompanyToken(token: string): void {
  localStorage.setItem("company_token", token);
}

export function getCompanyToken(): string | null {
  return localStorage.getItem("company_token");
}

export function clearCompanyToken(): void {
  localStorage.removeItem("company_token");
}
